import { render, staticRenderFns } from "./PaymentModal.vue?vue&type=template&id=3f389128&scoped=true"
import script from "./PaymentModal.vue?vue&type=script&lang=js"
export * from "./PaymentModal.vue?vue&type=script&lang=js"
import style0 from "./PaymentModal.vue?vue&type=style&index=0&id=3f389128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f389128",
  null
  
)

export default component.exports